module.exports = __webpack_public_path__ + "media/customize/banner-stack-bottom-0bdf822a.svg";